import { render } from "./EthiotelEthiopiaPrizes.vue?vue&type=template&id=d54240ac&scoped=true"
import script from "./EthiotelEthiopiaPrizes.vue?vue&type=script&lang=js"
export * from "./EthiotelEthiopiaPrizes.vue?vue&type=script&lang=js"

import "./EthiotelEthiopiaPrizes.vue?vue&type=style&index=0&id=d54240ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54240ac"]])

export default __exports__